import { Alert, Typography } from "@mui/material";
import CustomTable from "../../ui/CustomTable";
import { useWhatsAppNumber } from "./provider";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ActiveCell from "../Companies/CompanyTable/ActiveCell";
import ErrorsList from "../../ui/ErrorsList";
import InitialDate from "./Render/InitialDate";
import ExpireDate from "./Render/ExpireDate";

const ListWhatsAppNumber = () => {
  const navigate = useNavigate();

  const [error, setError] = useState();
  const [reload, setReload] = useState(false);
  const {
    state: { list },
    fetchList,
    remove,
  } = useWhatsAppNumber();
  const cols = [
    {
      label: "Title",
      name: "title",
      headTextLeft: true,
      textLeft: true,
    },
    {
      label: "Initial Date",
      name: "initialDate",
      customRender: InitialDate,
    },
    {
      label: "Expiry Date",
      name: "expiryDate",
      customRender: ExpireDate,
    },
    {
      label: "Status",
      name: "isActive",
      customRender: ActiveCell,
    },
  ];

  useEffect(() => {
    fetchList();
  }, [reload]);

  // const handleDelete = (id) => {
  //   try {
  //     remove(id);
  //     setReload(!reload);
  //   } catch (error) {
  //     setError(error.errors.message);
  //     console.error(error, "error");
  //   }
  // };
  return (
    <>
      <Typography variant="Poster" component="h4" mb={2}>
        WhatsApp List
      </Typography>
      {error && (
        <Alert severity="error" sx={{ m: 3 }}>
          <ErrorsList error={error} />
        </Alert>
      )}
      <CustomTable
        empty={list?.length === 0 ? true : false}
        cols={cols}
        data={list || []}
        filters={{
          add: () => {
            navigate("add");
          },
        }}
        actions={{
          edit: (id) => {
            navigate("edit/" + id);
          },
          // delete: (id) => {
          //   handleDelete(id);
          // },
        }}
        moreOptions={{
          detail: (id) => {
            navigate("detail/" + id);
          },
        }}
        isPagination={false}
      ></CustomTable>
    </>
  );
};

export default ListWhatsAppNumber;
